import React, { useEffect, useState } from 'react';
import { AgGridReact } from 'ag-grid-react';
import EditCollector from './EditCollector';
import AddCollector from './AddCollector';
import useFetch from '../../Utilities/useFetch';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import FuncFetch from '../../Utilities/funcFetch';
import { Form, Spinner } from 'react-bootstrap';

const AllCollectors = () => {
    const [rowData, setRowData] = useState([]);
    const [selectedCollector, setSelectedCollector] = useState(null);
    const [isEditFormOpen, setIsEditFormOpen] = useState(false);
    const [isAddFormOpen, setIsAddFormOpen] = useState(false);
    const { data: collectors, loading: collectorsLoading, refetch } = useFetch(true, `${process.env.REACT_APP_API_URL}/Admin/GetCollectors`, 'GET');

    useEffect(() => {
        if (collectors) {
            setRowData(collectors);
        }
    }, [collectors]);

    const openEditForm = (collector) => {
        setSelectedCollector(collector);
        setIsEditFormOpen(true);
    };

    const closeEditForm = () => {
        setSelectedCollector(null);
        setIsEditFormOpen(false);
        refetch();
    };

    const openAddForm = () => {
        setIsAddFormOpen(true);
    };

    const closeAddForm = () => {
        setIsAddFormOpen(false);
    };

    const refreshData = (collector) => {
        openEditForm(collector);
    };

    const handleDisableCollector = async (collectorId) => {
        try {
            await FuncFetch(`${process.env.REACT_APP_API_URL}/Admin/DisableCollector`, { collectorId }, 'POST');
            setRowData((prevData) =>
                prevData.map((collector) =>
                    collector.id === collectorId ? { ...collector, active: false } : collector
                )
            );
        } catch (error) {
            console.error('Error disabling collector:', error);
        }
    };       
    
    const onRowClicked = (event) => {
        openEditForm(event.data);
    }

    const columnDefs = [
        { headerName: 'ID', field: 'id', sortable: true, filter: true, width: 80 },
        { headerName: 'Collector', field: 'collector', sortable: true, filter: true },
        { headerName: 'Full Name', field: 'fullName', sortable: true, filter: true },
        { headerName: 'Email', field: 'emailAddress', sortable: true, filter: true },
        { headerName: 'Group', field: 'groupName', sortable: true, filter: true },
        {
            headerName: 'Active',
            field: 'active',
            sortable: true,
            filter: 'agSetColumnFilter',
            filterParams: {
                values: [true, false],
                valueFormatter: (params) => params.value ? 'Yes' : 'No'
            },
            cellRenderer: (params) => {
                return (
                    <Form.Check 
                        checked={params.data.active} 
                        disabled={!params.data.active} 
                        type="switch" 
                        id={`active-switch-${params.data.id}`}
                        label="Active" 
                        onChange={() => handleDisableCollector(params.data.id)} 
                    />
                )
            },
            width: 100
        },
        { 
            headerName: 'Admin', 
            field: 'isAdmin', 
            sortable: true, 
            filter: true,
            cellRenderer: params => params.value ? 'Yes' : 'No',
            width: 100
        },
        { 
            headerName: 'Payment Admin', 
            field: 'isPaymentAdmin', 
            sortable: true, 
            filter: true,
            cellRenderer: params => params.value ? 'Yes' : 'No',
            width: 140
        },
        { 
            headerName: 'Collector Admin', 
            field: 'isCollectorAdmin', 
            sortable: true, 
            filter: true,
            cellRenderer: params => params.value ? 'Yes' : 'No',
            width: 140
        },
        { 
            headerName: 'Can Reassign', 
            field: 'canReassign', 
            sortable: true, 
            filter: true,
            cellRenderer: params => params.value ? 'Yes' : 'No',
            width: 130
        },
        { 
            headerName: 'Can Close', 
            field: 'canClose', 
            sortable: true, 
            filter: true,
            cellRenderer: params => params.value ? 'Yes' : 'No',
            width: 110
        },
        { 
            headerName: 'Collection Min', 
            field: 'collectionMin', 
            sortable: true, 
            filter: true,
            width: 130
        },
        { 
            headerName: 'Collection Max', 
            field: 'collectionMax', 
            sortable: true, 
            filter: true,
            width: 130
        },
        { 
            headerName: 'Spanish', 
            field: 'spanish', 
            sortable: true, 
            filter: true,
            cellRenderer: params => params.value ? 'Yes' : 'No',
            width: 100
        },
        { 
            headerName: 'State Location', 
            field: 'stateLocation', 
            sortable: true, 
            filter: true 
        },
        { 
            headerName: 'Primary Project', 
            field: 'primaryProject', 
            sortable: true, 
            filter: true 
        },
        { 
            headerName: 'Second Project', 
            field: 'secondProject', 
            sortable: true, 
            filter: true 
        }
    ];

    return (
        <div>
            <Row style={{ marginTop: '10px'}}>
                <Col>
                    <h2>Collectors</h2>
                </Col>
                <Col>
                    {collectorsLoading && <Spinner animation="border"/>}
                </Col>
                <Col style={{display:'flex', justifyContent:'flex-end'}}>
                    <Button onClick={openAddForm}>
                        Add Collector
                    </Button>
                </Col>
            </Row>
            <div className="ag-theme-quartz grid">
                <AgGridReact
                    rowData={rowData}
                    columnDefs={columnDefs}
                    onRowClicked={onRowClicked}
                    defaultColDef={{
                        resizable: true,
                        sortable: true,
                        filter: true
                    }}
                />
            </div>
            
            {/* Edit Collector Modal */}
            {isEditFormOpen && (
                <EditCollector
                    collector={selectedCollector}
                    onClose={closeEditForm}
                    onSuccess={refreshData}
                />
            )}
            
            {/* Add Collector Modal */}
            {isAddFormOpen && (
                <AddCollector
                    show={isAddFormOpen}
                    onClose={closeAddForm}
                    onSuccess={refreshData}
                />
            )}
        </div>
    );
};

export default AllCollectors;